export enum ToastTypes {
  warning = "warning",
  info = "info",
  success = "success",
  error = "error",
}
